import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  IntegrationQueueLookupRequest,
  IntegrationQueueLookupResponse
} from '../models/integration-queue.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IntegrationQueueService {
  constructor(private api: ApiService) {}
  private baseUrl = environment.apiUrl;

  lookup(request: IntegrationQueueLookupRequest): Observable<IntegrationQueueLookupResponse> {
    return this.api.post<IntegrationQueueLookupResponse>(
      `${this.baseUrl}/IntegrationQueue/Lookup`,
      {
        Page: request.Page,
        PageSize: request.PageSize,
        SearchText: request.SearchText,
        ShowErrorsOnly: request.ShowErrorsOnly,
        ShowArchivedOnly: request.ShowArchivedOnly,
        ShowProducts: request.ShowProducts,
        ShowPrices: request.ShowPrices,
        ShowStocks: request.ShowStocks
      }
    );
  }
}